import {
    Directive, HostBinding, Inject, Input, OnInit, OnDestroy
} from '@angular/core';

import { AccordionDirective } from './accordion.directive';

@Directive({
    selector: '[appAccordionLink]',
    standalone: false
})
export class AccordionLinkDirective implements OnInit, OnDestroy {

  @Input() public group: any;

  @HostBinding('class.open')
  @Input()
  set open(value: boolean) {
      this._open = value;
      // console.log('value:', value);
      if (value) {
          this.nav.closeOtherLinks(this);
      }
  }
  get open(): boolean {
      return this._open;
  }

  protected _open: boolean = false;
  protected nav: AccordionDirective;

  public constructor(@Inject(AccordionDirective) nav: AccordionDirective) {
      this.nav = nav;
  }

  public ngOnInit(): any {
      this.nav.addLink(this);

      // console.log('group:', this.group);
      if (this.group) {
          const routeUrl = this.nav.getUrl();
          const currentUrl = routeUrl.split('/');
          // console.log('currentUrl:', currentUrl);
          // console.log(currentUrl.indexOf(this.group));
          if (currentUrl.indexOf(this.group) > 1) {
              this.toggle();
          }
      }
  }

  public ngOnDestroy(): any {
      this.nav.removeGroup(this);
  }

  public toggle(): any {
      // console.log('this.open:', this.open);
      // console.log('this._open:', this._open);
      this.open = !this.open;
  }
}
